import wxPromisify from '@/libs/promiseWx/wxPromisify';
import { isHdl } from '@haidilao-private/jsbridge';
import pathConfig from './pathConfig';
const md5 = require('js-md5');
const secretKey =
  '7AgMBAAECggEADpdQu75bmGiwrOsX0E8N6lqqLtO8OPiN1Fi21GM7bMNcj6yWtsNW3IZS6k6G';

/**
 * @description: 计算像素
 * @param {number} num
 * @return {*}
 */
export const $vw = function (num: number) {
  return (num / 375) * 100 + 'vw';
};

// 判断是否有网络
export const isOnLine = () => {
  let netStatus = '';
  if (window.navigator.onLine == true) {
    netStatus = 'onLine'; //网络链接正常
  } else {
    netStatus = 'offLine'; //网络连接失败
  }
  return netStatus;
};

/**
 * @description:判断环境
 * env ： app   WxChat 微信环境    H5 其他环境
 */
export function isEnv() {
  try {
    const ua = navigator.userAgent.toLowerCase();

    let env = '';
    //APP环境
    if (isHdl) env = 'App';
    //链接中有自定义渠道参数 则返回自定义的
    else if (getQuery('openChannel')) env = getQuery('openChannel');
    // 微信环境
    else if (ua.indexOf('micromessenger') !== -1) env = 'WxChat';
    //其他环境
    else env = 'H5';
    return env;
  } catch (err) {
    return 'H5'; //默认h5
  }
}

// 端外 设置导航栏标题（微信）
// 问题：页面加载完后 title已经确定了，所以不再监听title的change事件
// 解决：iframe是内lian kuang jia内联框架元素，可以将另一个html元素嵌入到当前页面，当异步货渠道数据后，动态创建的iframe根据制定src发送请求，从而触发title的舰艇，加载完后移除不会对页面造成影响
export const setDocumentTitle = (title: string) => {
  try {
    const document = window.document;
    document.title = title;
    const iframe = document.createElement('iframe');
    iframe.src = '/replace_title';
    iframe.style.display = 'none';
    const fn = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', fn);
        document.body.removeChild(iframe);
        console.log('title', document.title);
      }, 0);
    };
    iframe.addEventListener('load', fn);
    document.body.appendChild(iframe);
  } catch (err) {
    console.log(err);
  }
};

/**
 * 获取url query
 * @export
 * @param {*} getQuery
 * @returns
 */
export const getQuery = (paramName: string) => {
  const hash = decodeURIComponent(location.hash);
  const search = decodeURIComponent(location.search);
  let queryStr = search.substr(1); // search参数
  if (hash.split('?')[1]) queryStr += '&' + hash.split('?')[1]; // +query参数
  const query: any = {};
  queryStr &&
    queryStr.split('&').forEach((item) => {
      const tmp = item.split('=');
      query[tmp[0]] = tmp[1];
    }); // 拼接全部路由参数
  return paramName ? query[paramName] : query;
};

export const goWechat = (btnBoxRef: any) => {
  wxPromisify.checkReady().then(() => {
    btnBoxRef.current.innerHTML = `
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_94300eb818c2"
          path="pages/index/index"
          env-version=${pathConfig.ENV_VERSION}
          >
          <script type="text/wxtag-template">
          <style>
            .btn {
              width: 340px;
              height: 40px;
              font-size: 10px;
              display: flex;
              background-color: rgba(255, 255, 255, 0);
              justify-content: center;
              align-items: center;
            }
          </style>
          <div class="btn"></div>
          </script>
        </wx-open-launch-weapp>`;
  });
};
/**
 *微信h5打开微信小程序
 * @param btnBoxRef 绑定元素
 * @param username 原始id
 * @param path  跳转路径
 */
export const goWechatCustom = (
  btnBoxRef: any,
  username: string,
  path: string
) => {
  wxPromisify.checkReady().then(() => {
    btnBoxRef.current.innerHTML = `
      <wx-open-launch-weapp
        id="launch-btn"
        username=${username}
        path=${path}
        env-version=${pathConfig.ENV_VERSION}
        >
        <script type="text/wxtag-template">
        <style>.btn { width:100%;height:100%;position: absolute;top:0;left:0;background-color: rgba(255, 255, 255, 0); }</style>
        <div class="btn"></div>
      </script>
      </wx-open-launch-weapp>`;
  });
};

export const processingParameters = function (params: any) {
  let paramsArr = [];
  let paramsStr = '';
  for (const key in params) {
    paramsArr.push(key);
  }
  paramsArr = paramsArr.sort();
  paramsArr.forEach((item) => {
    if (
      params[item] !== '' &&
      params[item] !== null &&
      params[item] !== undefined
    ) {
      paramsStr += `${item}=${params[item]}&`;
    }
  });
  paramsStr += `key=${secretKey}`;
  console.log(paramsStr, 'paramsStr+++++++++++++=');

  return md5(paramsStr);
  // callback && callback(md5Str);
};

//验证是否是 英文符号
const isValid = (str: string): boolean => {
  return /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]/.test(str);
};

//英文符号转中文符文
export const half2all = (str: string): string => {
  let tmp = '';
  //遍历字符串 - 如果是英文符号转成中文符号
  for (let i = 0; i < str.length; i++) {
    if (isValid(str[i])) {
      tmp += String.fromCharCode(str.charCodeAt(i) + 65248);
    } else {
      tmp += str[i];
    }
  }
  return tmp;
};

/**
 * 判断环境
 */
export const getSysEnv = () => {
  const ua: any = navigator.userAgent.toLowerCase();
  const isWXWork = ua.match(/wxwork/i) == 'wxwork';
  const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger';
  let isMobile = false;
  let isDesktop = false;
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
    )
  ) {
    isMobile = true;
  } else {
    isDesktop = true;
  }

  if (isWeixin) {
    //微信
    return 'isWeixin';
  } else if (isDesktop) {
    // 在 pc 上则给提示引导到手机端打开
    return 'isDesktop';
  } else if (isMobile) {
    //在手机 其他环境的浏览器
    return 'isMobile';
  }
};

/**
 * 比对版本
 * @param oldVer_  老版本号
 * @param newVer_  新版本号
 * @returns
 */
export const compareVersions = (oldVer_: string, newVer_: string) => {
  const oldVersions: string[] = oldVer_.split('.');
  const newVersions: string[] = newVer_.split('.');

  const minL = Math.min(newVersions.length, oldVersions.length);
  let pos = 0; // 当前比较位
  let diff = 0; // 当前为位比较是否相等
  // 逐个比较如果当前位相等则继续比较下一位
  while (pos < minL) {
    diff = parseInt(newVersions[pos]) - parseInt(oldVersions[pos]);
    if (diff !== 0) {
      break;
    }
    pos++;
  }
  // 1是新版本  2是版本相等  3是旧版本
  if (diff > 0) {
    return '1';
  } else if (diff === 0) {
    if (newVersions.length > oldVersions.length) {
      return '1';
    } else {
      return '2';
    }
  } else {
    return '3';
  }
};
